/**
 * Breadcrumbs — the OMEGA-zoom path renderer used at L2/L3/log/etc.
 *
 * Each crumb is `{ label, to? }`. Crumbs without a `to` are the
 * current page (terminal, non-clickable, ink-muted).
 *
 * Visual register matches the rest of the OMEGA pages: bg-canvas
 * separators, text-ink-muted for non-active items, text-ink for the
 * active terminal item.
 */

import { Link } from 'react-router-dom';

import { cn } from '@/utils/cn';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-1 text-xs text-ink-muted"
    >
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={`${c.label}-${i}`} className="flex items-center gap-1">
            {c.to && !isLast ? (
              <Link to={c.to} className="hover:text-ink hover:underline">
                {c.label}
              </Link>
            ) : (
              <span className={cn(isLast ? 'text-ink' : 'text-ink-muted')}>{c.label}</span>
            )}
            {!isLast ? <span className="text-ink-subtle">›</span> : null}
          </span>
        );
      })}
    </nav>
  );
}
